import { createInertiaApp } from '@inertiajs/vue3'
import { Page } from '@inertiajs/core'
import { renderToString } from '@vue/server-renderer'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { createSSRApp, DefineComponent, h } from 'vue'
// @ts-ignore
import { modal, ModalPluginOptions } from 'momentum-modal'
import Layout from './Layouts/Layout.vue'
import * as Sentry from '@sentry/vue'
import { ZiggyVue } from 'ziggy-js'
import { PageProps } from './types'

const createInertiaAppProps = (ssr: boolean, page: Page<PageProps> | undefined = undefined) =>
    <Parameters<typeof createInertiaApp>[0]>{
        ...(ssr
            ? {
                  page,
                  render: renderToString,
              }
            : {}),
        title: (title) =>
            title ? `Sicher-Teilen.de | ${title}` : 'Sicher-Teilen.de | Dateien & Passwörter Ende-zu-Ende verschlüsselt teilen',
        resolve: async (name) => {
            const page = await resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob<DefineComponent>('./Pages/**/*.vue'))
            page.default.layout ??= Layout

            return page
        },
        setup({ el, App, props, plugin }) {
            const app = createSSRApp({ render: () => h(App, props) })

            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
                enabled: import.meta.env.VITE_SENTRY_ENABLED === true,
            })

            app.use(plugin)
                .use(ZiggyVue)
                .use(modal, {
                    resolve: (name: string) =>
                        resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob<DefineComponent>('./Pages/**/*.vue')),
                } as ModalPluginOptions)

            if (!ssr) app.mount(el)

            return app
        },
        progress: {
            color: '#4B5563',
        },
    }

export default createInertiaAppProps
